<div class="m-grid__item m-grid__item--fluid m-wrapper m-grid-responsive-lg">
    <ngx-spinner
        bdColor="rgba(75, 55, 100, 0.5)"
        size="large"
        color="#fff"
        type="line-scale-pulse-out">
            <span class="chevron left"></span>
            <span class="chevron right"></span>
    </ngx-spinner>

    <!--MAIN-->
    <div *ngIf="form" class="m-content">
        <!--begin::Portlet-->
        <div class="row m-row">
            <div class="col-lg-6">
                <div class="m-portlet">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 class="m-portlet__head-text">Organizations</h3>
                            </div>
                        </div>
                    </div>

                    <!--begin::Form-->
                    <form *ngIf="formLoaded" [formGroup]="form" class="m-form m-form--fit m-form--label-align-right">
                        <div class="m-portlet__body">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-4 col-form-label"> Name </label>
                                <div class="col-lg-8">
                                    <input type="text" class="form-control m-input"
                                        formControlName="name">
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body">
                            <div class="form-group m-form__group row">
                                <label class="col-lg-4 col-form-label"> Active </label>
                                <div class="col-lg-8">
                                    <label class="switch" style="padding-left: 10px; vertical-align: middle; text-align: center;">	
                                        <input		
                                            type="checkbox" class="form-control"
                                            formControlName="active" 
                                            >
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <button *ngIf="organization.organizationId == null" (click)="createOrUpdateOrganization()" type="button"
            class="btn btn-primary">Create</button>
        <button *ngIf="organization.organizationId != null" (click)="createOrUpdateOrganization()" type="button"
            class="btn btn-primary">Update</button>
        <button (click)="cancel()" type="button" class="btn btn-danger">Cancel</button>
    </div>
</div>